import { lazy } from "react";
export const lazyWithRetry = (importComponent) =>
  lazy(async () => {
    const hasForceRefresh = JSON.parse(window.localStorage.getItem("has_force_refresh") || "false");

    try {
      const component = await importComponent();
      window.localStorage.setItem("has_force_refresh", "false");
      return component;
    } catch (error) {
      if (!hasForceRefresh) {
        window.localStorage.setItem("has_force_refresh", "true");
        return window.location.reload();
      }
      throw error;
    }
  });

export const toSingular = (word) => {
  return word.endsWith("s") ? word.slice(0, -1) : word;
};

